<template>
    
</template>

<script lang="ts">
import { SweetAlertResult } from 'sweetalert2';
import { Vue, Component } from 'vue-facing-decorator';
import { EventBus } from '../../types/event_bus';

@Component
export default class VueComponentBase extends Vue implements EventBus {
    success(title: string, message: string): Promise<SweetAlertResult> {
        return this.$swal(title, message, 'success');
    }

    warning(title: string, message: string): Promise<SweetAlertResult> {
        return this.$swal(title, message, 'warning');
    }

    error(title: string, message: string): Promise<SweetAlertResult> {
        return this.$swal(title, message, 'error');
    }

    notify(title: string | Object, message: string, type?: string): Promise<SweetAlertResult> {
        if (typeof(title) === 'string') {
            return this.$swal(title as string, message, type);
        } else {
            return this.$swal(title);
        }
    }

    onEvents(events: string[], handler: (parameter: any) => void) {
        for (const event of events) {
            this.onEvent(event, handler);
        }
    }

    onEvent(event: string, handler: (parameter: any) => void) {
        window.EventBus.on(event, handler);
    }

    offEvents(events: string[], handler?: (parameter: any) => void){
        for (const event of events) {
            window.EventBus.off(event, handler);
        }
    }

    offEvent(event: string, handler?: (parameter: any) => void) {
        if (handler) {
            window.EventBus.off(event, handler);
        } else {
            window.EventBus.off(event);
        }
    }

    emitEvent(event: string, parameter?: any) {
        window.EventBus.emit(event, parameter);
    }

    emitEvents(events: string[], parameter?: any) {
        for (const event of events) {
            this.emitEvent(event, parameter);
        }
    }

    clearEvents() {
        window.EventBus.all.clear();
    }
}
</script>
